import { render, staticRenderFns } from "./RevisionDocumentosAlcoholes.vue?vue&type=template&id=7e5a849a&"
import script from "./RevisionDocumentosAlcoholes.vue?vue&type=script&lang=js&"
export * from "./RevisionDocumentosAlcoholes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports